<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.taskCode" clearable placeholder="任务编号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.orderCode" clearable placeholder="工单编号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.productNumber" clearable placeholder="产品编码" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.productName" clearable placeholder="产品名称" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.operationName" clearable placeholder="工序" style="width:140px" @keyup.enter.native="search" />
      <el-select v-model="query.taskState" clearable placeholder="状态" style="width:120px">
        <el-option label="待执行" value="00" />
        <el-option label="已开工" value="01" />
        <el-option label="已完成" value="02" />
        <el-option label="已取消" value="03" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="taskCode" label="任务编号" min-width="190" show-overflow-tooltip />
      <el-table-column prop="orderCode" label="工单编号" min-width="160" show-overflow-tooltip />
      <el-table-column prop="productNumber" label="产品编码" min-width="120" show-overflow-tooltip />
      <el-table-column prop="productName" label="产品名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="operationName" label="工序" min-width="140" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">{{ stateLabel(row.taskState) }}</template>
      </el-table-column>
      <el-table-column prop="plannedQty" label="计划量" width="90" align="right" />
      <el-table-column prop="doneQty" label="完成量" width="90" align="right" />
      <el-table-column prop="sort" label="顺序" width="70" align="center" />
      <el-table-column prop="planStart" label="计划开始" width="160" />
      <el-table-column prop="planEnd" label="计划结束" width="160" />
      <el-table-column label="操作" width="150" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" :disabled="row.taskState !== '00'" @click="doStart(row)">开工</el-button>
          <el-button type="text" :disabled="row.taskState !== '01'" @click="doFinish(row)">完成</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.taskState !== '00' && row.taskState !== '01'" @click="doCancel(row)">取消</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listOrderTask, startOrderTask, finishOrderTask, cancelOrderTask } from '../../api/orderTask'

const STATE_MAP = { '00': '待执行', '01': '已开工', '02': '已完成', '03': '已取消' }

export default {
  name: 'OrderTaskPage',
  components: { ListPagination },
  data() {
    return {
      query: { taskCode: '', orderCode: '', productNumber: '', productName: '', operationName: '', taskState: '' },
      routeOrderId: '',
      list: [], total: 0, page: 1, pageSize: 20, loading: false
    }
  },
  created() {
    if (this.$route.query.orderId) this.routeOrderId = this.$route.query.orderId
    this.load()
  },
  methods: {
    stateLabel(s) { return STATE_MAP[s] || s || '-' },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listOrderTask({
        currentPage: this.page, pageSize: this.pageSize,
        taskCode: this.query.taskCode,
        orderId: this.query.orderCode ? '' : this.routeOrderId,
        orderCode: this.query.orderCode,
        productNumber: this.query.productNumber,
        productName: this.query.productName,
        operationName: this.query.operationName,
        taskState: this.query.taskState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    act(row, fn, tip) {
      this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
        fn({ taskId: row.taskId, version: row.version }).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    doStart(row) { this.act(row, startOrderTask, '确认开工该任务？') },
    doFinish(row) { this.act(row, finishOrderTask, '确认完成该任务？') },
    doCancel(row) { this.act(row, cancelOrderTask, '确认取消该任务？') }
  }
}
</script>
